module.exports = __webpack_public_path__ + "static/fonts/AlibabaPuHuiTi-2-95-ExtraBold.7bc7c655.ttf";